/**
 * Generates a random password that meets the application's password requirements:
 * - 8-14 characters
 * - At least 1 uppercase letter
 * - At least 1 lowercase letter
 * - At least 1 number
 * - At least 1 special character
 * - No spaces
 */
export function generatePassword(length = 12): string {
    if (length < 8 || length > 14) {
        length = 12; // Default to 12 if invalid length
    }

    const lowercase = 'abcdefghijklmnopqrstuvwxyz';
    const uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const numbers = '0123456789';
    const specialChars = '!@#$%^&*()_+-=[]{};\':"|,.<>/?~';

    // Ensure at least one of each required character type
    let password = '';
    password += lowercase[Math.floor(Math.random() * lowercase.length)];
    password += uppercase[Math.floor(Math.random() * uppercase.length)];
    password += numbers[Math.floor(Math.random() * numbers.length)];
    password += specialChars[Math.floor(Math.random() * specialChars.length)];

    // Fill the rest with random characters from all sets
    const allChars = lowercase + uppercase + numbers + specialChars;
    for (let i = password.length; i < length; i++) {
        password += allChars[Math.floor(Math.random() * allChars.length)];
    }

    // Shuffle the password to avoid predictable patterns
    return password.split('').sort(() => Math.random() - 0.5).join('');
}

/**
 * Generates an email message for new user account creation
 */
export function generateWelcomeEmail(
    firstName: string,
    email: string,
    password: string
): string {
    const isAstraZeneca = email.toLowerCase().endsWith('@astrazeneca.com');
    
    const accessMessage = isAstraZeneca
        ? 'You can now access https://azepi.tessellon.com via the credentials below.'
        : 'You can access PRECISE via our client portal located at https://apps.tessellon.com';

    return `Hi ${firstName},

${accessMessage}

Please use the credentials below to login.

Your new account login is: ${email}
Your temporary password is: ${password}

You should be prompted to change your password on your first login. Please let us know if you have any issues.

Thanks,
Scott`;
}

